import "react-awesome-button/dist/styles.css";
import { Fade } from "react-awesome-reveal";
import { PiStudentFill } from "react-icons/pi";
import { FaTools } from "react-icons/fa";
import { SiRetool } from "react-icons/si";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FiLink } from "react-icons/fi";
import { Link } from "react-router-dom";
import { skillSets, knowledgeSets } from "../data/aboutData";

export default function Reference() {
  return (
    <div className="flex flex-col h-full px-3 overflow-x-hidden overflow-y-auto dark:bg-[#2a2a2a] bg-white py-100 transition-all duration-300">
      <div className="flex items-center justify-center w-full md:min-h-[120vh] mb-[80px] md:mb-[50px] mt-[70px] md:mt-2">
        <div className="max-w-[950px] items-start justify-start flex flex-col gap-7 text-center  w-full">
          <div className=" flex flex-col gap-5 w-full justify-center items-center mt-10 mb-20">
            <Fade delay={1200} triggerOnce={true}>
              <h1 className="uppercase md:text-[2.5em] text-[2em] text-center font-extrabold dark:text-[#cacaca] text-[#434343]">
                Trusted community
              </h1>
            </Fade>
            <Fade delay={600} triggerOnce={true}>
              <div className="p-2 justify-center items-center min-h-[200px] gap-10 flex md:flex-row flex-col dark:text-[#cacaca] text-[#434343]">
                <Link to={'https://x.com/theruneguardians'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer" >
                  <img src="imgs/trg.png" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">The Rune Guardians</p>
                  <p className=" text-[15px]">@theruneguardians</p>
                </Link>
                <Link to={'https://x.com/builderzdotdev'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/builderz.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">Builderz</p>
                  <p className=" text-[15px]">@builderzdotdev</p>
                </Link>
                <Link to={'https://x.com/CryptoClubG'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/cc.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">Crypto Club</p>
                  <p className=" text-[15px]">@CryptoClubG</p>
                </Link>
                <Link to={'https://x.com/StonedApeCrew'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/sac.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">Stoned Ape Crew</p>
                  <p className=" text-[15px]">@StonedApeCrew</p>
                </Link>
              </div>
            </Fade>
            <Fade delay={600} triggerOnce={true}>
              <div className="p-2 justify-center items-center min-h-[200px] gap-10 flex md:flex-row flex-col dark:text-[#cacaca] text-[#434343]">
                <Link to={'https://x.com/GaiminIo'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/gaimin.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">GAIMIN</p>
                  <p className=" text-[15px]">@GaiminIo</p>
                </Link>
                <Link to={'https://x.com/thesendcoin'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/send.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">SEND</p>
                  <p className=" text-[15px]">@thesendcoin</p>
                </Link>
                <Link to={'https://x.com/veterans_crew'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/veteran.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">Veterans</p>
                  <p className=" text-[15px]">@veterans_crew</p>
                </Link>
                <Link to={'https://x.com/BOZO_Rune'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/bozo.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">Bozo</p>
                  <p className=" text-[15px]">@BOZO_Rune</p>
                </Link>
              </div>
            </Fade>
            <Fade delay={600} triggerOnce={true}>
              <div className="p-2 justify-center items-center min-h-[200px] gap-10 flex md:flex-row flex-col dark:text-[#cacaca] text-[#434343]">
                <Link to={'https://x.com/GKingdom_io'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/gk.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">Galactic Kingdom</p>
                  <p className=" text-[15px]">@GKingdom_io</p>
                </Link>
                <Link to={'https://x.com/XCPinata'} target="_blank" className=" p-2 flex flex-col items-center gap-3 hover:scale-110 cursor-pointer">
                  <img src="imgs/sc.jpg" className="w-[150px] rounded-full" alt="avatar" />
                  <p className=" font-extrabold">XCPinata</p>
                  <p className=" text-[15px]">@XCPinata</p>
                </Link>
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  );
}
